module.exports = __webpack_public_path__ + "img/yidong.1c156e30.png";